import { FileText } from "lucide-react";
import { useFileLocalPreviewUrl } from "@tellescope/react-hooks";
import { FileImagePreview } from "./FileImagePreview";

interface FileLocalItemPreviewProps {
  file: File;
}

export const FileLocalItemPreview = ({ file }: FileLocalItemPreviewProps) => {
  const previewUrl = useFileLocalPreviewUrl(file);

  if (!previewUrl) {
    return <FileText className="h-4 w-4 text-muted-foreground flex-shrink-0" />;
  }

  return <FileImagePreview src={previewUrl} alt={file.name} />;
};
